import {
  FETCH_WRANGLING_REPORT,
  FETCH_WRANGLING_REPORT_SUCCESS,
  FETCH_WRANGLING_REPORT_FAILURE,
} from "features/yard360/store/wranglingReport/types";

export const INITIAL_WRANGLING_REPORT = {
  wranglings: {},
  fetchingWranglingReport: false,
  errorMessage: null,
};

export const wranglingReportReducer = (state = INITIAL_WRANGLING_REPORT, action) => {
  switch (action.type) {
    case FETCH_WRANGLING_REPORT:
      return {
        ...state,
        fetchingWranglingReport: true,
        errorMessage: null,
      };

    case FETCH_WRANGLING_REPORT_SUCCESS: {
      const { wranglings } = action.payload;
      return {
        ...state,
        wranglings,
        fetchingWranglingReport: false,
        errorMessage: null,
      };
    }

    case FETCH_WRANGLING_REPORT_FAILURE: {
      const { errorMessage } = action.payload;
      return {
        ...state,
        fetchingWranglingReport: false,
        errorMessage,
      };
    }

    default:
      return state;
  }
};
